module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "anchor"
  }, [_c('v-header', {
    attrs: {
      "config": _vm.headerData
    },
    on: {
      "startLesson": _vm.startLive,
      "endLesson": _vm.endLive,
      "IQNaire": _vm.issueQuestion,
      "studentQA": _vm.askQuestion,
      "clearEditor": _vm.clearCode,
      "checkCode": _vm.checkRole,
      "exportFile": _vm.exportCode
    }
  }), _vm._v(" "), _c('drag', {
    staticClass: "dragwrap",
    attrs: {
      "options": _vm.optionData
    }
  }, [_c('div', {
    ref: "work",
    staticClass: "work",
    attrs: {
      "slot": "uLeft"
    },
    slot: "uLeft"
  }, [_c('editor', {
    ref: "myEditor",
    attrs: {
      "isLive": true,
      "isCheck": _vm.check
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowQA),
      expression: "isShowQA"
    }],
    ref: "qaWrap",
    staticClass: "qa-wrap"
  }, [_c('div', {
    staticClass: "qa-notice"
  }, [_vm._v("\n          点击学生名字查看代码\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "qa-list"
  }, _vm._l((_vm.qaSet), function(item, index) {
    return _c('div', {
      key: 'qa-' + index,
      staticClass: "qa-item",
      class: _vm.qaItemActiveIndex == index ? 'active' : '',
      on: {
        "click": function($event) {
          _vm.getItemCode(item);
          _vm.qaItemActiveIndex = index
        }
      }
    }, [_c('span', [_vm._v(_vm._s(item.name || '匿名学员'))]), _vm._v(" "), _c('i', {
      staticClass: "icon iconfont icon-guanbi",
      on: {
        "click": function($event) {
          return _vm.closeQAItem(index)
        }
      }
    })])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "qa-close",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.closeQAWrap.apply(null, arguments)
      }
    }
  }, [_c('span', [_vm._v("关闭问答")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "work",
    attrs: {
      "slot": "uRight"
    },
    slot: "uRight"
  }, [_c('iterm', {
    attrs: {
      "isCompile": "1",
      "options": _vm.itermData,
      "tab": _vm.tab,
      "inputParam": _vm.inputParam,
      "compileInfo": _vm.compileInfo
    },
    on: {
      "insertTemplate": _vm.insertData
    }
  })], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.countdown),
      expression: "countdown"
    }],
    staticClass: "countdown"
  }, [_c('h1', [_vm._v(_vm._s(_vm.count))])]), _vm._v(" "), (_vm.qatip) ? _c('div', {
    staticClass: "qatip tip-wrap"
  }, [_c('div', {
    staticClass: "t-header"
  }, [_c('p', [_vm._v("提示")]), _vm._v(" "), _c('p', [_c('i', {
    staticClass: "icon iconfont icon-guanbi",
    on: {
      "click": function($event) {
        _vm.qatip = !_vm.qatip
      }
    }
  })])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "tb-wrap"
  }, [_c('div', {
    staticClass: "notip"
  }, [_c('i', {
    staticClass: "icon iconfont icon-baochi",
    class: {
      activeTip: _vm.isActiveTip
    },
    on: {
      "click": _vm.noTip
    }
  }), _vm._v("不再提醒\n      ")]), _vm._v(" "), _c('div', {}, [_c('button', {
    on: {
      "click": _vm.checkMenu
    }
  }, [_vm._v("切换")]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.noCheckMenu
    }
  }, [_vm._v("不切换")])])])]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ti-wrap"
  }, [_c('p', [_vm._v("当前直播窗口为学生窗口，需要将直播窗口切换给老师吗？点击‘切换’将关闭学生窗口。")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fdc25152","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/anchor/anchor.vue
// module id = 531
// module chunks = 1